import { useRouter } from 'next/router';
import React from 'react';
import Swal from 'sweetalert2';
import { getAppSettings } from '../AppSettings';
import { BreadCrumbItemProp } from '../types/BreadCrumb';

/**
 * Breadcrumb component for navigation.
 * @param param0
 * @returns
 */
export const BreadCrumb: React.FunctionComponent<{
  itemList: BreadCrumbItemProp[];
  isConfirm?: boolean;
}> = function ({ itemList, isConfirm }) {
  const onClick = (href: string) => {
    Swal.fire({
      title: '<span>Close</span>',
      html: 'Are you sure you want to close this<br/><span>page and return to previous page?</span> <br/><br/><span class="text-danger">* All unsaved data will be lost</span>',
      showCancelButton: true,
      allowOutsideClick: false,
      focusConfirm: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        Router.push(href);
      }
    });
  };

  const Router = useRouter();
  const renderLastItem = (name: string, href?: string) => {
    if (href) {
      if (isConfirm == true) {
        return (
          <a
            className='text-decoration-none ms-1 oa-blue fw-bold'
            href='#'
            onClick={() => onClick(href)}
          >
            {name}
          </a>
        );
      } else {
        return (
          <a
            className='text-decoration-none ms-1 oa-blue fw-bold'
            href={`${getAppSettings().basePath || ''}${href}`}
          >
            {name}
          </a>
        );
      }
    }

    return <p className='m-0 ms-1 oa-blue fw-bold'>{name}</p>;
  };

  const renderNotLastItem = (name: string, href?: string) => {
    if (href) {
      if (isConfirm == true) {
        return (
          <React.Fragment>
            <a
              className='text-decoration-none ms-1 oa-blue'
              href='#'
              onClick={() => onClick(href)}
            >
              {name}
            </a>
            {' > '}
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <a
              className='text-decoration-none ms-1 oa-blue'
              href={`${getAppSettings().basePath || ''}${href}`}
            >
              {name}
            </a>
            {' > '}
          </React.Fragment>
        );
      }
    }

    return (
      <p className='m-0 ms-1 oa-blue'>
        {name}
        {' > '}
      </p>
    );
  };

  const breadCrumbList = itemList.map((Q, index) => {
    if (index == itemList.length - 1) {
      return <div key={index}>{renderLastItem(Q.name, Q.href)}</div>;
    } else {
      return <div key={index}>{renderNotLastItem(Q.name, Q.href)}</div>;
    }
  });

  return (
    <div className='px-4 py-3'>
      <div className='flex-row d-flex'>{breadCrumbList}</div>
    </div>
  );
};
